import { VizPortalWebClientRequester } from '../api/VizPortalWebClientRequester';
import { WebClientFetchRequester, VIZPORTAL_API_PATH } from '../requester/WebClientFetchRequester';

/**
 * Create a vizportalWebClientRequester given web client prefix and hostName.
 */
export function vizPortalWebClientRequesterGenerator(apiPrefix = VIZPORTAL_API_PATH, hostName: string = ''): VizPortalWebClientRequester {
  return new VizPortalWebClientRequester(new WebClientFetchRequester(apiPrefix, hostName));
}